/**
 * Hierarchical role helpers: `reviewer ⊂ operator ⊂ admin`.
 *
 * ALWAYS compare by rank, NEVER by equality — an `operator` guard must admit
 * `admin`, and a `reviewer` guard must admit everyone. Equality silently locks
 * higher roles out of lower-privilege screens.
 */

import type { Role } from "../api/client";

const RANK: Record<Role, number> = {
  reviewer: 0,
  operator: 1,
  admin: 2,
};

/** True if `role` satisfies the `required` minimum role (hierarchical). */
export function roleAtLeast(role: Role | null | undefined, required: Role): boolean {
  if (!role) return false;
  return RANK[role] >= RANK[required];
}

/** Spanish label for a role (es-MX UI copy). */
export function roleLabel(role: Role): string {
  switch (role) {
    case "reviewer":
      return "Revisor";
    case "operator":
      return "Operador";
    case "admin":
      return "Administrador";
  }
}
